import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AuthInterceptor } from '@app/_interceptors/auth.interceptor';
import { AuthGuard } from '@app/_guards/auth.guard';
import { SharedModule } from '@app/shared/shared.module';
import { CoreModule } from '@app/core/core.module';

import { TournamentsService } from '@app/core/services/tournaments.services';

import { APP_PATH } from '@app/app.constants';
import {
    MatDialogModule,
    MatFormFieldModule,
    MatSelectModule,
    MatCheckboxModule,
    MatStepperModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatDatepickerModule,
    MatNativeDateModule
} from '@angular/material';

import { StartPageComponent } from './components/start-page/start-page.component';
import { AwardsComponent } from './components/awards/awards.component';

const resultsRoutes: Routes = [
    { path: '', component: StartPageComponent, canActivate: [AuthGuard] },
    { path: `${APP_PATH.results.awards}/:students_class_id`, component: AwardsComponent, canActivate: [AuthGuard] }
];

@NgModule({
    imports: [
        HttpClientModule,
        ReactiveFormsModule,
        FormsModule,
        CoreModule,
        CommonModule,
        SharedModule,
        RouterModule.forChild(resultsRoutes),
        // material
        MatDialogModule,
        MatFormFieldModule,
        MatSelectModule,
        MatCheckboxModule,
        MatStepperModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        MatDatepickerModule,
        MatNativeDateModule
    ],
    exports: [],
    declarations: [StartPageComponent, AwardsComponent],
    entryComponents: [],
    providers: [
        TournamentsService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        DatePipe
    ]
})
export class ResultsModule {}
